module.exports = __webpack_public_path__ + "img/undraw_Meeting_re_i53h.a6c58ec3.svg";